import { toast } from 'react-toastify';
import api from '../../Interceptor';
import {getRoute} from '../routes';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createPlan = async (plan) => {
  try {
    const response = await api.post(`/package`, plan);
    toast.success('Plan successfully created');
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || 'Error creating plan');
    throw error;
  }
};
export const getAllPlans = async () => {
  try {
    const response = await api.get(`/packages`);
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || 'Error fetching plans');
    throw error;
  }
};
export const updatePlanStatus = async (id, isActive) => {
  try {
    const response = await api.patch(`/package`, {isActive});
    toast.success('Status successfully updated');
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || 'Error updating plan status');
    throw error;
  }
};
export const deletePlan = async (id) => {
  try {
    const response = await api.delete(`/packages/${id}`);
    toast.success('Plan successfully deleted');
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || 'Error deleting plan');
    throw error;
  }
};
export const updatePlan = async (plan) => {
  try {
    const response = await api.put(`/package`, plan);
    toast.success('Plan successfully updated');
    return response.data;
  } catch (error) {
    toast.error(error.response?.data?.error || 'Error updating plan');
    throw error;
  }
};
export const successSubscription = async (planId) => {
  try {
    const response = await api.put(`/admin/payment/successSubscription`, {
      planId,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchUnreadCounts = async (userId) => {
  try {
    const response = await api.get(
      getRoute('users', 'admin', 'message', false) + `/unread-count/${userId}`
    );
    return response.data;
  } catch (error) {
    if (error?.isUnpaid) {
      return;
    }
    console.error('Failed to fetch unread counts', error);
  }
};
export const fetchUserUnreadCounts = async (userId) => {
  try {
    const response = await api.get(
      getRoute('users', 'user', 'message', false) + `/unread-count/${userId}`
    );
    return response.data;
  } catch (error) {
    if (error?.isUnpaid) {
      return;
    }
    console.error('Failed to fetch unread counts', error);
  }
};

export const getSubscriptionById = async () => {
  try {
    const response = await api.get(`admin/payment/getSubscriptionById`);
    return response.data;
  } catch (error) {
  if (error?.isUnpaid) {
      return;
    }
    console.error('Failed to fetch Subscription', error);
  }
}
